import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'

import PrimeVue from 'primevue/config';

import LanguageSelector from "@/components/LanguageSelector";
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Editor from 'primevue/editor';
import Fieldset from 'primevue/fieldset';
import FileUpload from "@/components/primevue/fileupload/FileUpload.vue";
// import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import Inplace from 'primevue/inplace';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputNumber from "@/components/primevue/inputnumber/InputNumber.vue";
import InputMask from 'primevue/inputmask';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import ProgressSpinner from 'primevue/progressspinner';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
// import ValidationMessage from 'primevue/validationmessage';

import '@/components/primevue/resources/themes/nova-light/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import '@fullcalendar/core/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import '@fullcalendar/timegrid/main.min.css';
import './assets/layout/layout.scss';
import i18n from './i18n'

// Vue.use(PrimeVue);
Vue.use(PrimeVue, {ripple: true});
Vue.use(ToastService);

Vue.directive('tooltip', Tooltip);

Vue.config.productionTip = false;

Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Button', Button);
Vue.component('Calendar', Calendar);
Vue.component('Card', Card);
Vue.component('Carousel', Carousel);
Vue.component('Chart', Chart);
Vue.component('Checkbox', Checkbox);
Vue.component('Chips', Chips);
Vue.component('Column', Column);
Vue.component('ContextMenu', ContextMenu);
Vue.component('DataTable', DataTable);
Vue.component('DataView', DataView);
Vue.component('DataViewLayoutOptions', DataViewLayoutOptions);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('Editor', Editor);
Vue.component('Fieldset', Fieldset);
Vue.component('FileUpload', FileUpload);
Vue.component('FullCalendar', FullCalendar);
Vue.component('Inplace', Inplace);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber);
Vue.component('InputMask', InputMask);
Vue.component('Listbox', Listbox);
Vue.component('MegaMenu', MegaMenu);
Vue.component('Menu', Menu);
Vue.component('Menubar', Menubar);
Vue.component('Message', Message);
Vue.component('MultiSelect', MultiSelect);
Vue.component('OrderList', OrderList);
Vue.component('OrganizationChart', OrganizationChart);
Vue.component('OverlayPanel', OverlayPanel);
Vue.component('Paginator', Paginator);
Vue.component('Panel', Panel);
Vue.component('PanelMenu', PanelMenu);
Vue.component('Password', Password);
Vue.component('PickList', PickList);
Vue.component('ProgressBar', ProgressBar);
Vue.component('RadioButton', RadioButton);
Vue.component('Rating', Rating);
Vue.component('SelectButton', SelectButton);
Vue.component('Slider', Slider);
Vue.component('Sidebar', Sidebar);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('SplitButton', SplitButton);
Vue.component('Steps', Steps);
Vue.component('TabMenu', TabMenu);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('TieredMenu', TieredMenu);
Vue.component('Toast', Toast);
Vue.component('Toolbar', Toolbar);
Vue.component('ToggleButton', ToggleButton);
Vue.component('Tree', Tree);
Vue.component('TreeTable', TreeTable);
Vue.component('TriStateCheckbox', TriStateCheckbox);
// Vue.component('ValidationMessage', ValidationMessage);
Vue.component('LanguageSelector', LanguageSelector);

// Production Environtment
Vue.prototype.$serviceBaseUrl = 'https://www.tirolibre.it/WebApi';
Vue.prototype.$rootSiteUrl = 'https://transfer.tirolibre.it';
Vue.prototype.$imageRootUrl = 'https://cdn.tirolibre.it';
Vue.prototype.$whatchat = 'https://chat.tirolibre.it:4001';

// Local Environtment
// Vue.prototype.$serviceBaseUrl = 'http://localhost:49886';
// Vue.prototype.$rootSiteUrl = 'http://localhost:8080';
// Vue.prototype.$imageRootUrl = 'https://cdn.tirolibre.it';
// Vue.prototype.$whatchat = 'http://localhost:4000';

// Global vars
Vue.prototype.$playerProfileId = 0;
Vue.prototype.$teamProfileId = 1;
Vue.prototype.$agentProfileId = 2;
Vue.prototype.$agentPlayerProfileId = 3;
Vue.prototype.$teamPlayerProfileId = 4;
Vue.prototype.$teamNotRegisteredProfileId = 5;
Vue.prototype.$teamNotRegisteredNotAccepted = 6;
Vue.prototype.$coachingStaffProfileId = 7;
Vue.prototype.$coachingStaffPlayerProfileId = 8;

Vue.prototype.$amountActivation = 18;

Vue.prototype.$agentStandard = 0;
Vue.prototype.$agentLocalPartner = 1;
Vue.prototype.$agentTirolibre = 2;

Vue.prototype.$whatchatTirolibreUserName = "Paolo Vullo";
Vue.prototype.$whatchatTirolibreEmail = "paolo.vullo@tirolibre.it";
Vue.prototype.$whatchatTirolibreBaseUserId = 30953;
Vue.prototype.$whatchatTirolibrePassword = "AFAyqVNAf/OuvXHJ5tTv8F7sHM5UozzUgfyvvnMAAK93rBQlpr6yfFyhDkPqM9y/sw==";
Vue.prototype.$whatchatTirolibreImage = "/ImageRepository/Agent/30953/personal_0c62de55-8a23-4a20-9695-5ebcfefc887b.jpg";
Vue.prototype.$whatchatNegotiationConversationType = 1;

// user roles
Vue.prototype.$administrator = 1;
Vue.prototype.$agent = 2;
Vue.prototype.$player = 3;
Vue.prototype.$team = 4;
Vue.prototype.$coachingStaff = 5;
Vue.prototype.$agentPremium = 6;

// Global vars used on whatchat
Vue.prototype.$whatchatTirolibreUserId = 1;
Vue.prototype.$whatchatNegotiationConversationType = 1;
Vue.prototype.$whatchatOneToOneConversationType = 2;
Vue.prototype.$whatchatChatGroupConversationType = 3;
Vue.prototype.$elixirWhatchatNegotiationConversationType = "Elixir.WhatChat.Discussions.Conversation.ConversationType.Negotiation";
Vue.prototype.$elixirWhatchatOneToOneConversationType = "Elixir.WhatChat.Discussions.Conversation.ConversationType.OneToOne";
Vue.prototype.$elixirWhatchatChatGroupConversationType = "Elixir.WhatChat.Discussions.Conversation.ConversationType.ChatGroup";

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
